export default {
    userName:'你好哦',
}



// WEBPACK FOOTER //
// ./src/store/state.js